<template>
  <div class="sunchartdiv" ref="chartdiv"></div>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import * as am4plugins_sunburst from "@amcharts/amcharts4/plugins/sunburst";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

import { mapState } from "vuex";
import _ from "lodash";
export default {
  methods: {
    setAllData() {
      let sunData = this.$store.getters.getterVesselDemExp;
      this.init(sunData);
    },
    init(dataSun) {
      am4core.useTheme(am4themes_animated);
      let chart = am4core.create(
        this.$refs.chartdiv,
        am4plugins_sunburst.Sunburst
      );

      chart.padding(0, 0, 0, 0);
      chart.radius = am4core.percent(98);
      chart.data = dataSun;
      chart.colors.step = 2;
      chart.fontSize = 12;
      // chart.innerRadius = am4core.percent(8);

      // define data fields
      chart.dataFields.value = "value";
      chart.dataFields.name = "name";
      chart.dataFields.children = "children";
      chart.dataFields.color = "colors";

      let level0SeriesTemplate = new am4plugins_sunburst.SunburstSeries();
      level0SeriesTemplate.hiddenInLegend = false;
      chart.seriesTemplates.setKey("0", level0SeriesTemplate);
      // this makes labels to be hidden if they don't fit
      level0SeriesTemplate.labels.template.truncate = true;
      level0SeriesTemplate.labels.template.hideOversized = true;
      level0SeriesTemplate.dataFields.name = chart.dataFields.name;
      level0SeriesTemplate.labels.template.adapter.add("rotation", function(
        rotation,
        target
      ) {
        target.maxWidth =
          target.dataItem.slice.radius - target.dataItem.slice.innerRadius - 10;
        target.maxHeight = Math.abs(
          ((target.dataItem.slice.arc *
            (target.dataItem.slice.innerRadius +
              target.dataItem.slice.radius)) /
            2) *
            am4core.math.RADIANS
        );
        return rotation;
      });
      level0SeriesTemplate.slices.template.events.on("over", function(event) {
        if (event.target.dataItem.sunburstDataItem.children) {
          event.target.cursorOverStyle = am4core.MouseCursorStyle.pointer;
        }
      });

      const vm = this;
      level0SeriesTemplate.slices.template.events.on("hit", function(event) {
        vm.$store.dispatch("setType", "tanker");
        vm.$store.dispatch("setTankerName", event.target.dataItem.name);
      });

      let level1SeriesTemplate = new am4plugins_sunburst.SunburstSeries();
      chart.seriesTemplates.setKey("1", level1SeriesTemplate);
      level1SeriesTemplate.fillOpacity = 0.75;
      level1SeriesTemplate.hiddenInLegend = true;
      level1SeriesTemplate.labels.template.truncate = true;
      level1SeriesTemplate.labels.template.hideOversized = true;
      level1SeriesTemplate.labels.template.adapter.add("rotation", function(
        rotation,
        target
      ) {
        target.maxWidth =
          target.dataItem.slice.radius - target.dataItem.slice.innerRadius - 10;
        target.maxHeight = Math.abs(
          ((target.dataItem.slice.arc *
            (target.dataItem.slice.innerRadius +
              target.dataItem.slice.radius)) /
            2) *
            am4core.math.RADIANS
        );
        return rotation;
      });

      level1SeriesTemplate.slices.template.events.on("hit", function(event) {
        vm.$store.dispatch("setType", "tanker");
        vm.$store.dispatch(
          "setTankerName",
          event.target._dataItem.properties.category
        );
      });
      level1SeriesTemplate.slices.template.events.on("over", function(event) {
        if (event.target.dataItem.sunburstDataItem.children) {
          event.target.cursorOverStyle = am4core.MouseCursorStyle.pointer;
        }
      });

      let level2SeriesTemplate = new am4plugins_sunburst.SunburstSeries();
      chart.seriesTemplates.setKey("2", level2SeriesTemplate);
      // console.log(level2SeriesTemplate);
      level2SeriesTemplate.fillOpacity = 0.5;
      level2SeriesTemplate.hiddenInLegend = true;
      level2SeriesTemplate.labels.template.truncate = true;
      level2SeriesTemplate.labels.template.hideOversized = true;
      level2SeriesTemplate.slices.template.events.on("hit", function(event) {
        vm.$store.dispatch("setType", "vessel");
        vm.$store.dispatch(
          "setTankerName",
          event.target._dataItem.properties.category
        );
      });
      level2SeriesTemplate.slices.template.events.on("over", function(event) {
        event.target.cursorOverStyle = am4core.MouseCursorStyle.pointer;
      });
      level2SeriesTemplate.labels.template.adapter.add("rotation", function(
        rotation,
        target
      ) {
        target.maxWidth =
          target.dataItem.slice.radius - target.dataItem.slice.innerRadius - 10;
        target.maxHeight = Math.abs(
          ((target.dataItem.slice.arc *
            (target.dataItem.slice.innerRadius +
              target.dataItem.slice.radius)) /
            2) *
            am4core.math.RADIANS
        );
        return rotation;
      });
      chart.legend = new am4charts.Legend();
    },
  },
  mounted() {
    this.setAllData();
  },
  computed: {
    ...mapState({
      dataSun: (state) => state.vesselTrip.data,
      refineryName: (state) => state.greenDieselCardActive.refineryName,
    }),
  },
  watch: {
    dataSun(newValue, oldValue) {
      if (!_.isEqual(newValue, oldValue)) {
        this.setAllData();
      }
    },
  },
};
</script>

<style>
.sunchartdiv {
  width: 100%;
  height: 400px;
}
</style>
